import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Button, Grid, Typography, Link } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { genfunction } from 'helpers'

import {
    actionGetOrderLocationsByDisplayArea, actionGetOrderMenuByDisplayArea,
    actionSetOrderLocation, actionResetPaymentTransaction
} from 'actions'

import { actionStartAppLoader, actionEndAppLoader } from 'actions/actionAppLoader';
import ErrorHandling from 'components/ErrorHandling/ErrorHandling';
import MenuItem from './components/MenuItem'

const { ShowOrderItemPriceAs } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(5)
        }
    },
    MenuImage: {
        width: 100,
        height: 100,
        maxWidth: 100,
        maxHeight: 100
    },
    MenuBox: {
        cursor: "pointer"
    }
}));

const OrderMenu = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const [errorMsg, seterrorMsg] = useState("");

    const payment = useSelector(state => state.reducerPaymentTransaction.Payment);
    const orderLocationsLoading = useSelector(state => state.reducerOrderLocations.loading);
    const orderLocations = useSelector(state => state.reducerOrderLocations.orderLocations);
    const orderLocation = useSelector(state => state.reducerOrderLocations.orderLocation);
    const orderMenuloading = useSelector(state => state.reducerOrderMenu.loading);
    const orderMenu = useSelector(state => state.reducerOrderMenu.orderMenu);
    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);

    useEffect(() => {
        if (payment && payment.ReceiptNo && payment.ReceiptNo.toString().length > 0) {
            actionResetPaymentTransaction(dispatch);
        }
    }, []);

    useEffect(() => {
        if (props.match.path == "/ordermenu/:id") {
            if (orderLocations == undefined || orderLocations.length == 0)
                actionGetOrderLocationsByDisplayArea(dispatch, 0);
        }
        else {
            props.history.push('/notfound');
        }
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        if (orderLocations && orderLocations.length > 0) {
            var tabLocationID = props.match.params.id;
            let tl = { ...orderLocations.find(x => x.TabLocations.find(x => x.TabLocationID == tabLocationID) != undefined) };
            tl.TabLocations = tl.TabLocations.filter(x => x.TabLocationID == tabLocationID);
            actionSetOrderLocation(dispatch, tl);
            actionGetOrderMenuByDisplayArea(dispatch, tl.DisplayArea);
        }
    }, [orderLocations])

    useEffect(() => {
        if (orderLocationsLoading || orderMenuloading) {
            actionStartAppLoader(dispatch);
        }
        else if (orderLocationsLoading == false && orderMenuloading == false) {
            actionEndAppLoader(dispatch);
        }
    }, [orderLocationsLoading, orderMenuloading])


    const errorcancelhandle = () => {
        seterrorMsg("");
    }

    const onClickCheckoutHandler = () => {
        if (orderProducts && orderProducts.length > 0) {
            props.history.push('/revieworderproducts');
        }
        else {
            seterrorMsg("Please select item first");
        }
    }

    if (orderLocation == undefined || orderMenu == undefined)
        return null
    else
        return (
            <Grid className={classes.root} container spacing={2} justifyContent="center">
                <ErrorHandling msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />
                <Grid item xs={12} align="center">
                    <Typography variant="h1" color="textPrimary" >You are ordering from</Typography>
                    <Typography component={"a"} variant="subtitle1" color="textPrimary" >{orderLocation.OrderLocation + " , "}</Typography>
                    <Link
                        style={{ textDecoration: "underline" }}
                        component="a"
                        variant="subtitle1"
                        onClick={() => {
                            props.history.push('/orderlocationtab/' + orderLocation.OrderLocation);
                        }}
                    >
                        {orderLocation.TabLocations[0].TabLocationName}
                    </Link>
                </Grid>
                <Grid item container spacing={1} xs={12} sm={6} md={4} aligh="center">
                    {orderMenu.map(menu => {
                        return (
                            <MenuItem key={menu.MenuName} Menu={menu} {...props} />
                        )
                    })}
                </Grid>
                <Grid container item xs={12} justifyContent="center">
                    <Grid item container spacing={1} xs={12} sm={6} md={4} align="center">
                        <Grid item xs={6} align="left">
                            <Button variant="outlined" color="primary"
                                onClick={() => { props.history.push('/orderlocation'); }}
                            >
                                Start Over
                            </Button>
                        </Grid>
                        <Grid item xs={6} align="right">
                            <Button variant="contained" color="primary" onClick={onClickCheckoutHandler}>
                                Checkout {genfunction.ccyFormat(ShowOrderItemPriceAs.toLowerCase() == "inctax" ? genfunction.getOrderProductsTotalPrice(orderProducts).total : genfunction.getOrderProductsTotalPrice(orderProducts).subtotal)}</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
};

export default OrderMenu;